module.exports = __webpack_public_path__ + "static/img/persion4.f53d18c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/persion4.png
// module id = tgK6
// module chunks = 1